import UtilsUrl from "../../utils/UtilsUrl";
import api from "./../api";

class OrderService {

    updateOrderCreationDate(idUser, reference, creationDate) {
      return api.put(
        UtilsUrl.OrderPosURL() +
          `/updateOrderCreationDate/${idUser}/${reference}/${creationDate}`
      );
    }
  getTicketCaisseDetails(id, dateDebutToFilter, dateFinToFilter) {
    return api.get(UtilsUrl.OrderPosURL() + "/getTicketsCaisse/" + id, {
      params: {
        dateDebutToFilter: dateDebutToFilter,
        dateFinToFilter: dateFinToFilter,
      },
    });
  }
  getTicketShopDetails(id, dateDebutToFilter, dateFinToFilter) {
    return api.get(UtilsUrl.OrderPosURL() + "/getTicketsShop/" + id, {
      params: {
        dateDebutToFilter: dateDebutToFilter,
        dateFinToFilter: dateFinToFilter,
      },
    });
  }

  getCreditShopDetails(id, dateDebutToFilter, dateFinToFilter) {
    return api.get(UtilsUrl.OrderPosURL() + "/getTicketsCreditShop/" + id, {
      params: {
        dateDebutToFilter: dateDebutToFilter,
        dateFinToFilter: dateFinToFilter,
      },
    });
  }

    getTicketsCaisseByRefAndIdUser(id, ref) {
    return api.get(UtilsUrl.OrderPosURL() + "/getTicketsCaisseByRefAndIdUser/" + id+"/"+ref);
  }
  getAllPayementsTicketsCaisses(id, dateDebutToFilter, dateFinToFilter) {
    return api.get(
      UtilsUrl.OrderPosURL() + "/getAllPayementsTicketsCaisses/" + id,
      {
        params: {
          dateDebutToFilter: dateDebutToFilter,
          dateFinToFilter: dateFinToFilter,
        },
      }
    );
  }
  removeTicketsCaisses(id, ref) {
    return api.put(
      UtilsUrl.OrderPosURL() + "/deleteOrderByRef/" + id + "/" + ref
    );
  }
  getAllPayementsTicketsShop(id, dateDebutToFilter, dateFinToFilter) {
    return api.get(
      UtilsUrl.OrderPosURL() + "/getAllPayementsTicketsShop/" + id,
      {
        params: {
          dateDebutToFilter: dateDebutToFilter,
          dateFinToFilter: dateFinToFilter,
        },
      }
    );
  }
  getChiffreOrderBySocieteAndShop(id,idShop, dateDebutToFilter, dateFinToFilter) {
    return api.get(UtilsUrl.OrderPosURL() + "/getChiffreOrderBySocieteAndShop/" + id+"/"+idShop, {
      params: {
        debutDate: dateDebutToFilter,
        finDate: dateFinToFilter,
      },
    });
  }
    getTicketsKPI(idShop, dateDebutToFilter, dateFinToFilter) {
    return api.get(UtilsUrl.OrderPosURL() + "/getTicketsKPI/"+idShop, {
      params: {
        dateDebutToFilter: dateDebutToFilter,
        dateFinToFilter: dateFinToFilter,
      },
    });
  }


  echangePayementOrder(model) {
    return api.post(UtilsUrl.PayementPosURL() + "/echangePayementOrder",model);
  }

    getAllPayementsTraitesShop(idShop, dateDebutToFilter, dateFinToFilter) {
    return api.get(UtilsUrl.PayementPosURL() + "/getAllPayementsTraitesShop/" + idShop, {
      params: {
        dateDebutToFilter: dateDebutToFilter,
        dateFinToFilter: dateFinToFilter,
      },
    });
  }

      getAllPayementsTraitesShopDateEcheance(idShop, dateDebutToFilter, dateFinToFilter) {
    return api.get(UtilsUrl.PayementPosURL() + "/getAllPayementsTraitesShopDateEcheance/" + idShop, {
      params: {
        dateDebutToFilter: dateDebutToFilter,
        dateFinToFilter: dateFinToFilter,
      },
    });
  }
}
export default new OrderService();
